import { FieldMapValue } from '../../types/utils/common'

export const oonCondition = (v?: FieldMapValue) => !v?.noBenefits
